import { Key, ReactNode } from 'react';
import { Table as AntTable } from 'antd';
import { ColumnType, TableProps } from 'antd/lib/table';
import { TableRowSelection } from 'antd/lib/table/interface';

import styles from './table.module.scss';
import { StrictOmit } from '../../types';

interface ICustomerListProps<CustomerType> {
  data?: CustomerType[];
  isLoading?: boolean;
  panel?: (record: readonly CustomerType[]) => ReactNode;
  columns: ColumnType<CustomerType>[];
  getRowKey: (customer: CustomerType) => Key;
  rowSelection?: TableRowSelection<CustomerType>;
}

// TODO: This component was first intended for customer only, but is used for any item (basically). Refactor namings here.
const Table = <CustomerType extends object>({
  data,
  columns,
  isLoading,
  panel,
  getRowKey,
  rowSelection,
  ...restTableProps
}: ICustomerListProps<CustomerType> &
  StrictOmit<TableProps<CustomerType>, 'dataSource'>) => (
  <AntTable
    title={panel}
    loading={isLoading}
    bordered
    rowKey={getRowKey}
    columns={columns}
    dataSource={data}
    className={styles.table}
    rowSelection={rowSelection}
    {...restTableProps}
  />
);

export default Table;
